export const staticMenuRoutes = [
    {
        name: '个人资料',
        path: 'system/user/profile',
        component: '/system/user/profile/index',
        meta: {
            name: 'profile',
            hidden: true
        }
    },
    {
        name: '可视化大屏',
        path: 'big-screen',
        component: '/bigScreen/index',
        meta: {
            name: 'bigScreen',
            hidden: true
        }
    }
    // 系统管理菜单
    // {
    //     name: '大屏',
    //     path: 'gden',
    //     meta: {
    //         name: 'gden',
    //         icon: 'SettingOutlined',
    //     },
    //     children: [
    //         {
    //             name: '可视化大屏',
    //             path: 'vltdhd',
    //             component: '/gden/vltdhd/index',
    //             meta: {
    //                 name: 'vltdhd',
    //                 icon: 'MenuOutlined',
    //                 hidden: false
    //             }
    //         },
    //     ]
    // },

];
